import { render } from "./PatientActivityLevelAdd.vue?vue&type=template&id=6b20e8d2&scoped=true"
import script from "./PatientActivityLevelAdd.vue?vue&type=script&lang=js"
export * from "./PatientActivityLevelAdd.vue?vue&type=script&lang=js"

import "./PatientActivityLevelAdd.vue?vue&type=style&index=0&id=6b20e8d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b20e8d2"]])

export default __exports__